import axios from 'axios';

const API_URL = `${process.env.REACT_APP_DOMAIN}/api/user_management`;

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const login = async (username, password) => {
  const response = await axios.post(`${API_URL}/token/`, { username, password });
  const { access, refresh } = response.data;
  localStorage.setItem('token', access);
  localStorage.setItem('refreshToken', refresh);
  setAuthToken(access);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  setAuthToken(null);
};

export const refreshToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (refreshToken) {
    try {
      const response = await axios.post(`${API_URL}/token/refresh/`, { refresh: refreshToken });
      const { access } = response.data;
      localStorage.setItem('token', access);
      setAuthToken(access);
      return access;
    } catch (error) {
      console.error('Error refreshing token:', error);
      logout();
    }
  }
  return null;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};